//Component
import AppDispatcher from '../core/AppDispatcher.jsx';
//Constants
import AppConstants from '../constants/ApplicationConstants.js';
var ApplicationActionTypes = AppConstants.ActionTypes;

//Utilities
import { EventEmitter } from 'events';
var _ = require('lodash');
var Validators = require('../utils/Validators.js');
var Products = require('../utils/Products');

//local variables
const CHANGE_EVENT = 'change';

var _errorList = [], _validationSummary = [],_productId;

let _model = {
    isAdviserAuthorised: AppConstants.YesNoValues.YES
};

function updateAdviserAuthorityModel(fieldId, value) {
    _model[fieldId] = (value);
    _errorList = [];
    _validationSummary = [];
}

function retrieveAdviserAuthority(application) {
    let adviserAuthority = _.get(application, 'form.adviserAuthority');
    if (adviserAuthority) {
        _model = _.cloneDeep(adviserAuthority);
    }
}
function validateAdviserAuthority() {
    if (_productId && !Products.isAnnuity(_productId)) {
        let id = 'adviserAuthoritySection';
        let user = window.NOA.userContext;
        if (user && user.isAdviser) {
            let data = { adviserAuthority: _model.isAdviserAuthorised };
            let rule = { adviserAuthority: 'required' };
            let customAttribute = { adviserAuthority: 'Adviser Authority' };
            _errorList = Validators.validateAll(data, rule, customAttribute, id);
            _validationSummary = Validators.validateAll(data, rule, customAttribute, id, 'Adviser Authority');
        }
    }
}
function setProductId(productId) {
    _productId = productId;
}

class AdviserAuthorityStoreClass extends EventEmitter {

    constructor() {
        super();
    }

    emitChange() {
        this.emit(CHANGE_EVENT);
    }

    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }

    getAdviserAuthorityModel() {
        return _model;
    }

    getErrorList() {
        return _errorList;
    }

    getSummaryErrorList(){
        return _validationSummary;
    }

    isValid() {
        return _errorList.length === 0;
    }
}

const AdviserAuthorityStore = new AdviserAuthorityStoreClass();

AdviserAuthorityStore.dispatchToken = AppDispatcher.register((action) => {

    switch (action.actionType) {
        case ApplicationActionTypes.APPLICATION_SAVE_VALIDATE:
        case ApplicationActionTypes.VALIDATE_APPLICATION:
            validateAdviserAuthority();
            break;
        case ApplicationActionTypes.UPDATE_ADVISER_TRANSACT_AUTHORITY:
            updateAdviserAuthorityModel(action.fieldId, action.value);
            break;
        case ApplicationActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            setProductId(action.applicationData.productId);
            retrieveAdviserAuthority(action.applicationData);
            break;
        case ApplicationActionTypes.NEW_APPLICATION_INITIALISED:
            setProductId(action.productId);
            break;

        default:
            return true;
    }

    AdviserAuthorityStore.emitChange();
    return true;
});

export default AdviserAuthorityStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/AdviserAuthorityStore.js